import { Group, Text } from "@mantine/core";
import { useMemo } from "react";

import { useGetGiveaways } from "../../../api/insights";
import { RankedBarChart } from "../charts";
import SectionShell, {
  usePartShown,
  Stat,
  StatGrid,
  formatNum,
  formatPct,
} from "../SectionShell";

function Giveaway({ eventId }) {
  const { data, isPending, isError, error } = useGetGiveaways(eventId);
  const showMostPopularSponsor = usePartShown("mostPopularSponsor");

  const scansPerSponsor = useMemo(
    () =>
      (data?.scansPerSponsor ?? [])
        .map((s) => ({
          sponsor: s.name ?? "(unknown)",
          Scans: Number(s.scanCount ?? 0),
        }))
        .sort((a, b) => b.Scans - a.Scans),
    [data]
  );

  return (
    <SectionShell
      id="giveaway"
      title="Giveaway"
      description="Sponsor scan / giveaway participation."
      isPending={isPending}
      isError={isError}
      error={error}
      eventId={eventId}
      analysisKey="giveaway"
    >
      <StatGrid>
        <Stat
          part="sponsors"
          label="Sponsors"
          value={formatNum(data?.totalSponsors)}
        />
        <Stat
          part="totalScans"
          label="Total scans"
          value={formatNum(data?.totalScans)}
        />
        <Stat
          part="participants"
          label="Participants"
          value={formatNum(data?.totalParticipants)}
        />
        <Stat
          part="completionRate"
          label="Completion rate"
          value={formatPct(data?.completionRate)}
        />
      </StatGrid>

      {showMostPopularSponsor &&
        data?.mostPopularSponsor &&
        Number(data.mostPopularSponsor.scanCount) > 0 && (
          <Group gap="xs">
            <Text fw={600} size="sm">
              Most popular sponsor:
            </Text>
            <Text size="sm">
              {data.mostPopularSponsor.name} (
              {formatNum(data.mostPopularSponsor.scanCount)} scans)
            </Text>
          </Group>
        )}

      <RankedBarChart
        part="scansPerSponsor"
        title="Scans per sponsor"
        data={scansPerSponsor}
        categoryKey="sponsor"
        series={[{ name: "Scans", color: "blue.6" }]}
      />
    </SectionShell>
  );
}

export default Giveaway;
